import {graphqlClient} from '@/store/apollo/apollo';
import store from '@/store/store';

export default function(code: string) {
  return store.getters.languageName(code);
}
